import { Button, Group, Modal } from '@mantine/core';
import { useState } from 'react';
import TextInput from 'src/components/design-system/input/TextInput';

type Props = {
  opened: boolean;
  label: string;
  onClose: () => void;
  // Called only with a name that is new and not blank.
  onRename: (label: string) => void;
};

/**
 * Renames a model, from its own page or from the models list. Mount it afresh each time it
 * opens, so it starts from the model's current name.
 */
export function RenameModelModal({ opened, label, onClose, onRename }: Props) {
  const [value, setValue] = useState(label);
  const rename = () => {
    const next = value.trim();
    onClose();
    if (next && next !== label) {
      onRename(next);
    }
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Rename model" centered>
      <TextInput
        label="Model name"
        value={value}
        onChange={event => setValue(event.currentTarget.value)}
        data-autofocus
      />
      <Group justify="flex-end" gap="sm" mt="md">
        <Button variant="subtle" size="xs" onClick={onClose}>
          Cancel
        </Button>
        <Button size="xs" disabled={!value.trim()} onClick={rename}>
          Rename
        </Button>
      </Group>
    </Modal>
  );
}
